<template>

  <div class="callCenter">暂未开放

    <router-view />

  </div>
</template>

<script>
  export default {
    data () {
      return {
        
      }
    },
 
    methods: {
      
    }
  }
</script>

<style scoped>
.callCenter {
  background: #FFFFE6;
  border: 2px solid #89c33f ;
  margin: 5% 0;
  padding: 5%;
  color: #603813;
  font-size: 16px;
  font-weight: bold;
}
@media screen and (max-width: 700px) {
.el-col-14 {
    width: 150%;
}
}
</style>


// WEBPACK FOOTER //
// src/components/callCenter.vue